export default function isLocalStorageAvailable() {
	try {
		window.localStorage
		return true
	}
	catch {
		return false
	}
}